<template>
  <div>
    <div class="mb-4 flex items-center justify-end gap-1.5 text-xs uppercase tracking-wide lg:hidden">
      <span>View</span>
      <button
        v-for="option in mobileColumnOptions"
        :key="`mobile-${option}`"
        type="button"
        class="flex h-7 min-w-[28px] items-center justify-center border px-2 py-1 transition-colors"
        :class="selectedMobileColumns === option ? 'border-black bg-black text-white' : 'border-black/20'"
        :aria-label="`Show ${option} columns`"
        :aria-pressed="selectedMobileColumns === option"
        @click="setMobileColumns(option)"
      >
        <span
          class="flex items-end gap-[2px] transition-opacity"
          :class="selectedMobileColumns === option ? 'opacity-100' : 'opacity-60'"
        >
          <span
            v-for="bar in option"
            :key="`mobile-${option}-${bar}`"
            class="h-3 w-[2px] bg-current"
          />
        </span>
      </button>
    </div>
    <div class="mb-4 hidden items-center justify-end gap-1.5 text-xs uppercase tracking-wide lg:flex">
      <span>View</span>
      <button
        v-for="option in desktopColumnOptions"
        :key="`desktop-${option}`"
        type="button"
        class="flex h-7 min-w-[28px] items-center justify-center border px-2 py-1 transition-colors"
        :class="selectedDesktopColumns === option ? 'border-black bg-black text-white' : 'border-black/20'"
        :aria-label="`Show ${option} columns`"
        :aria-pressed="selectedDesktopColumns === option"
        @click="setDesktopColumns(option)"
      >
        <span
          class="flex items-end gap-[2px] transition-opacity"
          :class="selectedDesktopColumns === option ? 'opacity-100' : 'opacity-60'"
        >
          <span
            v-for="bar in option"
            :key="`desktop-${option}-${bar}`"
            class="h-3 w-[2px] bg-current"
          />
        </span>
      </button>
    </div>
    <div
      class="grid gap-x-4 gap-y-2 sm:gap-x-8 md:gap-x-12"
      :class="{
        'grid-cols-1': selectedMobileColumns === 1,
        'grid-cols-2': selectedMobileColumns === 2,
        'lg:grid-cols-2': selectedDesktopColumns === 2,
        'lg:grid-cols-3': selectedDesktopColumns === 3,
        'lg:grid-cols-4': selectedDesktopColumns === 4,
      }"
    >
      <collection-product
        v-for="(product, index) in products"
        :key="product.id"
        :product="product"
        :product-index="index"
        :selected-columns="selectedDesktopColumns"
        :selected-mobile-columns="selectedMobileColumns"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("collection");
const DESKTOP_STORAGE_KEY = "plp-columns";
const MOBILE_STORAGE_KEY = "plp-mobile-columns";
const DEFAULT_DESKTOP_COLUMNS = 3;
const DEFAULT_MOBILE_COLUMNS = 1;
const DESKTOP_COLUMN_OPTIONS = [2, 3, 4];
const MOBILE_COLUMN_OPTIONS = [1, 2];

export default {
  data() {
    return {
      desktopColumnOptions: DESKTOP_COLUMN_OPTIONS,
      mobileColumnOptions: MOBILE_COLUMN_OPTIONS,
      selectedDesktopColumns: DEFAULT_DESKTOP_COLUMNS,
      selectedMobileColumns: DEFAULT_MOBILE_COLUMNS,
    };
  },
  computed: mapState(["products"]),
  mounted() {
    try {
      const storedDesktopColumns = parseInt(window.localStorage.getItem(DESKTOP_STORAGE_KEY), 10);
      if (DESKTOP_COLUMN_OPTIONS.includes(storedDesktopColumns)) {
        this.selectedDesktopColumns = storedDesktopColumns;
      }

      const storedMobileColumns = parseInt(window.localStorage.getItem(MOBILE_STORAGE_KEY), 10);
      if (MOBILE_COLUMN_OPTIONS.includes(storedMobileColumns)) {
        this.selectedMobileColumns = storedMobileColumns;
      }
    } catch (error) {
      // Ignore storage access errors (private mode / blocked storage)
    }
  },
  methods: {
    setDesktopColumns(option) {
      if (!DESKTOP_COLUMN_OPTIONS.includes(option)) {
        return;
      }
      this.selectedDesktopColumns = option;
      try {
        window.localStorage.setItem(DESKTOP_STORAGE_KEY, String(option));
      } catch (error) {
        // Ignore storage access errors (private mode / blocked storage)
      }
    },
    setMobileColumns(option) {
      if (!MOBILE_COLUMN_OPTIONS.includes(option)) {
        return;
      }
      this.selectedMobileColumns = option;
      try {
        window.localStorage.setItem(MOBILE_STORAGE_KEY, String(option));
      } catch (error) {
        // Ignore storage access errors (private mode / blocked storage)
      }
    },
  },
};
</script>
